<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="/static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div style="line-height:33px">
          <h1>卡号充值</h1>
          <p>用户名：{{email}}</p>
          <p>卡号：{{code}} {{status}}。<span v-show="state">（本卡只能使用一次）</span></p>
          <p v-show="state">点击确认，立即添加{{count}}次请求次数</p>
          <Button @click="modal1 = true" class="btn" v-show="state">确认</Button>
          <Modal
            v-model="modal1"
            title="充值确认"
            @on-ok="charge"
            @on-cancel="cancel">
            <p>确认充值吗</p>
        </Modal>

        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'
import helper from '../lib/helper'

export default {
  components: {
    Header
  },

  data () {
    return {
      modal1: false,
      email: '',
      code: '',
      count: 0,
      status: '有效',
      state: false
    }
  },
  mounted () {
    this.getUserInfo()
    this.getCardInfo()
  },
  methods: {
    getCardInfo () {
      this.code = this.$route.params.c

      if (this.code.length === 0) {
        this.$Message.info('错误，卡号为空')
        return
      }
      var url = this.$store.state.baseurl + '/mapi/charge/card'
      // console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
          params: {
            code: this.code
          }
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          if (res.data.data) {
            that.count = res.data.data.count
            if (res.data.data.status === 0) {
              that.status = '已失效'
              that.state = false
            } else {
              that.status = '有效'
              that.state = true
            }
            if (res.data.data.used === 1) {
              that.status = '已使用'
              that.state = false
            }
          }
        } else if (res.data.code === 401) {
          window.location.href = '/login'
        } else {
          that.status = '已失效'
          that.state = false
          that.$Message.info(res.data.msg)
        }
      }).catch((e) => {
        that.status = '已失效'
        that.state = false
        that.$Message.info('获取卡号信息错误')
      })
    },
    getUserInfo () {
      var uinfo = helper.getUser()
      // console.log('mine user info', uinfo)
      if (uinfo) {
        this.email = uinfo.email
      }
      var url = this.$store.state.baseurl + '/mapi/user/userorder'
      // console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          that.tools = res.data.data
          // console.log('获取用户信息', res.data)
        } else if (res.data.code === 401) {
          window.location.href = '/login'
        } else {
          that.$Message.info(res.data.msg)
          window.location.href = '/login'
        }
      }).catch((e) => {
        console.log('获取信息失败', e)
        that.$Message.info('获取信息失败')
      })
    },
    charge () {
      this.docharge()
    },
    cancel () {
    },
    docharge () {
      var url = this.$store.state.baseurl + '/mapi/charge/do'
      console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
          params: {
            code: this.code
          }
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          that.$Message.info('充值成功！')
          window.location.href = '/mine'
        } else if (res.data.code === 401) {
          window.location.href = '/login'
        } else {
          console.log(res.data)
          that.$Message.info(res.data.msg)
          window.location.href = '/'
        }
      }).catch((e) => {
        console.log('获取信息失败', e)
        that.$Message.info('获取信息失败')
      })
    }
  }
}
</script>
<style lang="less" scoped>
a:hover {
  color: #177ff5;
}
a:link{color: #177ff5;}
a:visited{color: #177ff5;}
.box {
  margin: 60px auto;
  width: 840px;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/charge.vue